import React from 'react';
import { faShip } from '@fortawesome/free-solid-svg-icons';
import { WidgetRow, WidgetFooter, WidgetEmpty, Pill, Age, useGoTo } from './common';

// Used for both "Shipment overview" (everything in progress) and "My
// deliveries" (the ones I am part of); the server returns the same shape.
const ShipmentOverviewWidget = ({ data }) => {
  const goTo = useGoTo();
  const items = data.items || [];
  const groups = data.groups || [];
  return (
    <>
      {groups.length > 0 && (
        <div className="mydesk-groups">
          {groups.map((g) => (
            <span key={g.status} className="mydesk-group"><strong>{g.count}</strong> {g.label}</span>
          ))}
        </div>
      )}
      {items.length === 0 && <WidgetEmpty>No deliveries in progress.</WidgetEmpty>}
      {items.map((d) => (
        <WidgetRow
          key={d.id}
          icon={faShip}
          tone="brand"
          title={d.vessel_name || d.number || 'Delivery'}
          subtitle={[d.number, d.commodity_label, [d.seller_name, d.buyer_name].filter(Boolean).join(' to '), d.bl_date ? `BL ${d.bl_date}` : ''].filter(Boolean).join(' · ')}
          right={(
            <>
              <Pill tone={d.status_tone || 'neutral'}>{d.status}</Pill>
              <Age>{d.age_label}</Age>
            </>
          )}
          onClick={() => goTo(d.url)}
        />
      ))}
      <WidgetFooter label="Open Trade Operations" url={data.url} />
    </>
  );
};

export default ShipmentOverviewWidget;
